import type { TransactionListComponentProps } from '@bitte-ai/types';
import { ShowDetailsBtn } from './ShowDetailsBtn';
import { TxnFees } from './TxnFees';
import { TxnDetail } from './near/TxnDetail';

export const TxnListWrapper = ({
  accountId,
  costs,
  gasPrice,
  transaction,
  modifiedUrl,
  showDetails,
  showTxnDetail,
  setShowTxnDetail,
  operation,
  borderColor,
}: TransactionListComponentProps): JSX.Element => {
  return (
    <div className="bitte-mx-auto bitte-flex bitte-w-full bitte-flex-col bitte-gap-1">
      <div className="bitte-flex bitte-w-full bitte-flex-col bitte-justify-center bitte-rounded">
        <ShowDetailsBtn
          setShowDetails={setShowTxnDetail}
          showDetails={showTxnDetail}
          displayName="Transaction Details"
        />

        {showTxnDetail ? (
          <TxnFees
            costs={costs || []}
            gasPrice={gasPrice || ''}
            transaction={transaction as any}
            operation={operation}
            borderColor={borderColor}
          />
        ) : null}

        {transaction?.length > 0 ? (
          <TxnDetail
            accountId={accountId}
            costs={costs || []}
            gasPrice={gasPrice || ''}
            transaction={transaction as any}
            modifiedUrl={modifiedUrl}
            showDetails={showDetails}
            showTxnDetail={showTxnDetail}
          />
        ) : null}
      </div>
    </div>
  );
};
